export default __webpack_public_path__ + "static/media/novofineplus.12b1c6a4.png";